/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-07-08 09:44:42
 * @LastEditors: linxi
 * @LastEditTime: 2022-07-11 09:32:56
 */

export function getOrgaztionnName(c: any) {
  switch (c) {
    case '0':
      return '所有机构'
    case '1':
      return '医保机构'
    default:
      return ''
  }
}
